/* tslint:disable */
/* eslint-disable */
/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { TeamReviewSettingsDto } from '../models';
/**
 * TeamReviewSettingsApi - axios parameter creator
 */
export const TeamReviewSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {string} [teamReviewSettingsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsGet: async (teamId: string, teamReviewSettingsId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamReviewSettingsGet', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/TeamReviewSettings`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (teamReviewSettingsId !== undefined) {
                localVarQueryParameter['teamReviewSettingsId'] = teamReviewSettingsId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {TeamReviewSettingsDto} [teamReviewSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsPost: async (teamId: string, teamReviewSettingsDto?: TeamReviewSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamReviewSettingsPost', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/TeamReviewSettings`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamReviewSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {TeamReviewSettingsDto} [teamReviewSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsPut: async (teamId: string, teamReviewSettingsDto?: TeamReviewSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamReviewSettingsPut', 'teamId', teamId)
            const localVarPath = `/api/teams/{teamId}/TeamReviewSettings`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(teamReviewSettingsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} teamReviewSettingsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete: async (teamId: string, teamReviewSettingsId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'teamId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete', 'teamId', teamId)
            // verify required parameter 'teamReviewSettingsId' is not null or undefined
            assertParamExists('apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete', 'teamReviewSettingsId', teamReviewSettingsId)
            const localVarPath = `/api/teams/{teamId}/TeamReviewSettings/{teamReviewSettingsId}`
                .replace(`{${"teamId"}}`, encodeURIComponent(String(teamId)))
                .replace(`{${"teamReviewSettingsId"}}`, encodeURIComponent(String(teamReviewSettingsId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TeamReviewSettingsApi - functional programming interface
 */
export const TeamReviewSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TeamReviewSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} teamId 
         * @param {string} [teamReviewSettingsId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamReviewSettingsGet(teamId: string, teamReviewSettingsId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamReviewSettingsGet(teamId, teamReviewSettingsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamReviewSettingsApi.apiTeamsTeamIdTeamReviewSettingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {TeamReviewSettingsDto} [teamReviewSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamReviewSettingsPost(teamId: string, teamReviewSettingsDto?: TeamReviewSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamReviewSettingsPost(teamId, teamReviewSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamReviewSettingsApi.apiTeamsTeamIdTeamReviewSettingsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {TeamReviewSettingsDto} [teamReviewSettingsDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamReviewSettingsPut(teamId: string, teamReviewSettingsDto?: TeamReviewSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamReviewSettingsPut(teamId, teamReviewSettingsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamReviewSettingsApi.apiTeamsTeamIdTeamReviewSettingsPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} teamId 
         * @param {string} teamReviewSettingsId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete(teamId: string, teamReviewSettingsId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete(teamId, teamReviewSettingsId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TeamReviewSettingsApi.apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TeamReviewSettingsApi - factory interface
 */
export const TeamReviewSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TeamReviewSettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsGet(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamReviewSettingsGet(requestParameters.teamId, requestParameters.teamReviewSettingsId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsPost(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamReviewSettingsPost(requestParameters.teamId, requestParameters.teamReviewSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsPut(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamReviewSettingsPut(requestParameters.teamId, requestParameters.teamReviewSettingsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete(requestParameters.teamId, requestParameters.teamReviewSettingsId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiTeamsTeamIdTeamReviewSettingsGet operation in TeamReviewSettingsApi.
 */
export interface TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsGetRequest {
    readonly teamId: string

    readonly teamReviewSettingsId?: string
}

/**
 * Request parameters for apiTeamsTeamIdTeamReviewSettingsPost operation in TeamReviewSettingsApi.
 */
export interface TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPostRequest {
    readonly teamId: string

    readonly teamReviewSettingsDto?: TeamReviewSettingsDto
}

/**
 * Request parameters for apiTeamsTeamIdTeamReviewSettingsPut operation in TeamReviewSettingsApi.
 */
export interface TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPutRequest {
    readonly teamId: string

    readonly teamReviewSettingsDto?: TeamReviewSettingsDto
}

/**
 * Request parameters for apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete operation in TeamReviewSettingsApi.
 */
export interface TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDeleteRequest {
    readonly teamId: string

    readonly teamReviewSettingsId: string
}

/**
 * TeamReviewSettingsApi - object-oriented interface
 */
export class TeamReviewSettingsApi extends BaseAPI {
    /**
     * 
     * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamReviewSettingsGet(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsGetRequest, options?: RawAxiosRequestConfig) {
        return TeamReviewSettingsApiFp(this.configuration).apiTeamsTeamIdTeamReviewSettingsGet(requestParameters.teamId, requestParameters.teamReviewSettingsId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamReviewSettingsPost(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPostRequest, options?: RawAxiosRequestConfig) {
        return TeamReviewSettingsApiFp(this.configuration).apiTeamsTeamIdTeamReviewSettingsPost(requestParameters.teamId, requestParameters.teamReviewSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamReviewSettingsPut(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsPutRequest, options?: RawAxiosRequestConfig) {
        return TeamReviewSettingsApiFp(this.configuration).apiTeamsTeamIdTeamReviewSettingsPut(requestParameters.teamId, requestParameters.teamReviewSettingsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete(requestParameters: TeamReviewSettingsApiApiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return TeamReviewSettingsApiFp(this.configuration).apiTeamsTeamIdTeamReviewSettingsTeamReviewSettingsIdDelete(requestParameters.teamId, requestParameters.teamReviewSettingsId, options).then((request) => request(this.axios, this.basePath));
    }
}

